import { Component } from '@angular/core';

@Component({
  selector: 'app-web-terms-conditions',
  templateUrl: './web-terms-conditions.component.html',
  styleUrls: ['./web-terms-conditions.component.scss'],
})
export class WebTermsConditionsComponent {

}
